import { Route, Routes } from "react-router-dom";
import Grid from '@mui/material/Unstable_Grid2';
import Error from '../../pages/error';
import Inbox from '../../pages/inbox';
import BackOfficeCenter from "../../pages/backoffice-center";
import BackOfficeCompany from "../backoffice/BackOfficeCompany";
import TesteGrid from "../general/grid/TesteGrid";

function HomePage() {
  return (
    <Grid container sx={{marginBlockStart:'64px', marginInlineStart: '60px'}}>
      <Grid xs={12}>
        <Routes>
          <Route path="/" element={<Inbox />} />
          <Route path='*' element={<Error />} />
          <Route path="/companies" element={<BackOfficeCenter />} />
          <Route path="/companies/:id" element={<BackOfficeCompany />} />
          <Route path="/teste" element={<TesteGrid />} />
        </Routes>
      </Grid>
    </Grid>
  );
}

export default HomePage;
